<template>
  <v-card>
    <v-card-title>Alarm Details - Original Alarm Text</v-card-title>

    <v-card-text class="tab-card">

        <v-tabs v-model="tab" color="#ffffff">
            <v-tabs-slider color="#ffffff"></v-tabs-slider>
            <v-tab key="history/remarks">History/Remarks</v-tab>
            <v-tab key="details">Details</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" class="tab-content-full-height">
            <v-tab-item key="history/remarks" style="height: 100%;">
                <v-textarea class="alarm-details-historyremarks history" height="100%" v-model="formattedHistoryText" readonly no-resize outlined  color="#c42111">
                    <template v-slot:label>
                        <span style="width: 125px; display: block;">Alarm History 
                            <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                                <template v-slot:activator="{ on }">
                                    <v-icon style="margin-top: -4px;" v-on="on">mdi-information-outline</v-icon>
                                </template>
                                <span v-html="pageMethodsInfo" />
                            </v-tooltip>
                        </span>
                    </template>
                </v-textarea>

                <v-textarea class="alarm-details-historyremarks" height="100%" v-model="formattedRemarksText" readonly no-resize outlined label="Remarks" color="#c42111"></v-textarea>
            </v-tab-item>

            <v-tab-item key="details" style="height: 100%; overflow-y: auto;">
                <v-textarea class="alarm-details" height="100%" v-model="$props.alarm.details.text" readonly no-resize outlined label="Original Alarm Text" color="#c42111"></v-textarea>
                <v-textarea class="alarm-details" height="100%" v-model="unmodifiedAlarm" readonly no-resize outlined label="Unmodified Alarm" color="#c42111"></v-textarea>

                <div v-if="$props.alarm.details.children.length">
                    <span class="children-alarms-label">Child Alarms</span>
                    <alarms-list :alarms="$props.alarm.details.children" :alarmGridResources="$props.alarmGridResources" eid="ag-grid-children-alarms-container" :parentAlarmId="$props.alarm.alarm_id" @parentCleared="$emit('close')" :style="{height: compHeight, maxHeight: compHeight, minHeight: '300px'}" />
                </div>
            </v-tab-item>
        </v-tabs-items>

    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn text @click="$emit('close')">Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import AlarmsList from "@/components/Alarms/AlarmsList";
export default {
    name: 'AlarmDetails',
    props: ['alarm', 'alarmGridResources'],
    components: {
        AlarmsList,
    },
    data: () => ({
        showChildrenAlarmsList: true,
        tab: 0,
    }),

    computed: {
        unmodifiedAlarm: function() {
            return `Alarm Description: ${this.$props.alarm.details.original.alarm_description} \n\nAlarm Severity: ${this.$props.alarm.details.original.alarm_severity}`;
        },

        compHeight() {
            return `${(this.$props.alarm.details.children.length * 36) + 34 + 16}px`;
        },

        formattedHistoryText() {
            if(this.$props.alarm.details.alarm_history && this.$props.alarm.details.alarm_history.length) {
                return this.$props.alarm.details.alarm_history.join('\n');
            }
            return "";
        },

        formattedRemarksText() {
            if(this.$props.alarm.details.alarm_remarks && this.$props.alarm.details.alarm_remarks.length) {
                return this.$props.alarm.details.alarm_remarks.join('\n');
            }
            return "";
        },

        pageMethodsInfo() {
            return `<u>Page Methods</u><br>
            <b>M</b> - Email<br>
            <b>S</b> - SMS<br>
            <b>T</b> - Telegram<br>
            <b>W</b> - Whatsapp<br>
            <b>H</b> - Microsoft Teams<br>
            <b>C</b> - Webapp Pop-Up<br>
            <b>A</b> - Audio<br>
            <b>P</b> - Push Notification<br>`;
        }
    },

    methods: {
    },

    watch: {
        alarm: {
            handler(newVal, oldVal) {
            },
        }
    },

    mounted() {
    }
};
</script>

<style scoped>

    .children-alarms-label {
        font-weight: bold;
        font-size: 22px;
        color: #ffffff;
        display: block;
    }

    .tab-content-full-height {
        height: calc(100% - 30px);
    }
    
    .tab-card {
        height: calc(80vh - 40px);
    }

    .alarm-details-historyremarks {
        display: block;
        height: calc(100% - 0px);
        width: calc(50% - 3px);
        float: left;
        margin-top: 10px;
    }
    .alarm-details-historyremarks.history {
        margin-right: 6px;
    }

    .alarm-details {
        display: block;
        height: calc(50% - 10px);
        margin-top: 10px;
    }

</style>

<style>

    #ag-grid-children-alarms-container {
        margin-top: 10px;
        height: 100%;
    }

    #ag-grid-children-alarms-container .ag-row-hover {
        background-color: #c8e6c9 !important;
    }

    #ag-grid-children-alarms-container .ag-row-selected {
        background-color: #0000ff !important;
        color: #ffffff !important;
    }

    .alarm-details-historyremarks .v-input__control {
        height: 100%;
    }
    .alarm-details .v-input__control {
        height: 100%;
    }

</style>
